import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { h } from '@debbie/cortex/dist/index.js';
import * as tribunalAPI from '@debbie/cortex/dist/api/tribunal.js';
import TribunalJob from './TribunalJob.js';
import SearchInput from '../../SearchInput.js';
import Well from '../../Well.js';
import { InternationalTribunalJobType, tribunalJobReferenceCaseMap, TribunalJobType, } from '@debbie/common/dist/tribunal/jobs/types.js';
import HistItem from '../../Hist/HistItem.js';
import { selectAllUsers } from '@debbie/cortex/dist/users/selectors.js';
import ResendBetalingspaakrav from './JobCreators/ResendBetalingspaakrav.js';
import Register1Paategning from './JobCreators/Register1Paategning.js';
import Register2Paategning from './JobCreators/Register2Paategning.js';
import ClosedObjection from './JobCreators/ClosedObjection.js';
import CourtMeeting from './JobCreators/CourtMeeting.js';
import Distraint from './JobCreators/Distraint.js';
import RegisterInsolvency from './JobCreators/Insolvency.js';
import Policepresentation from './JobCreators/Policepresentation.js';
import ResendStaevning from './JobCreators/ResendStaevning.js';
import RegisterVerdict from './JobCreators/RegisterVerdict.js';
import ResendFogedBegaering from './JobCreators/ResendFogedBegaering.js';
import UserPreview from '../../UserPreview.js';
import q from '@debbie/cortex/dist/query.js';
import { tribunalJobsEntity, useTribunalCaseJobsByTribunalCaseId, } from '@debbie/cortex/dist/tribunal/index.js';
import keys from '@debbie/common/dist/cache/keys.js';
export const TribunalCase = (props) => {
    const lang = useSelector((s) => s.lang);
    const users = useSelector(selectAllUsers);
    const [jobType, setJobType] = useState(null);
    const _tribunalCaseJobsLoadable = useTribunalCaseJobsByTribunalCaseId(props.id);
    const _tribunalCaseJobs = h.hasData(_tribunalCaseJobsLoadable)
        ? _tribunalCaseJobsLoadable.data
        : null;
    const tribunalCaseJobs = _tribunalCaseJobs
        ? _tribunalCaseJobs.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
        : [];
    const jobProps = {
        tenantId: props.tenantId,
        caseSeqId: props.caseSeqId,
        pastJobs: tribunalCaseJobs,
        tribunalCase: props.tribunalCase,
        onSubmit: async () => {
            setJobType(null);
        },
    };
    const Job = {
        // DK
        [TribunalJobType.CreateBetalingspaakrav]: (
        // Initial job
        React.createElement(React.Fragment, null)),
        [TribunalJobType.ResendBetalingspaakrav]: (React.createElement(ResendBetalingspaakrav, { ...jobProps })),
        [TribunalJobType.GLResendBetalingspaakrav]: (React.createElement(ResendBetalingspaakrav, { ...jobProps, is_greenland: true })),
        [TribunalJobType.Register1Paategning]: (React.createElement(Register1Paategning, { ...jobProps })),
        [TribunalJobType.Register2Paategning]: (React.createElement(Register2Paategning, { ...jobProps })),
        [TribunalJobType.ClosedObjection]: React.createElement(ClosedObjection, { ...jobProps }),
        [TribunalJobType.CourtMeeting]: React.createElement(CourtMeeting, { ...jobProps }),
        [TribunalJobType.CreateFogedrekvisition]: (
        // Initial job
        React.createElement(React.Fragment, null)),
        [TribunalJobType.Distraint]: React.createElement(Distraint, { ...jobProps }),
        [TribunalJobType.RegisterInsolvency]: React.createElement(RegisterInsolvency, { ...jobProps }),
        [TribunalJobType.RegisterPolicePresentation]: (React.createElement(Policepresentation, { ...jobProps })),
        // GL
        [TribunalJobType.CreateStaevning]: (
        // Initial job
        React.createElement(React.Fragment, null)),
        [TribunalJobType.ResendStaevning]: React.createElement(ResendStaevning, { ...jobProps }),
        [TribunalJobType.RegisterVerdict]: React.createElement(RegisterVerdict, { ...jobProps }),
        [TribunalJobType.CreateFogedbegaering]: (
        // Initial job
        React.createElement(React.Fragment, null)),
        [TribunalJobType.ResendFogedbegaering]: (React.createElement(ResendFogedBegaering, { ...jobProps })),
        [TribunalJobType.RegisterInsolvens]: React.createElement(RegisterInsolvency, { ...jobProps }),
    };
    return (React.createElement("div", null,
        React.createElement(SearchInput, { placeholder: 'Vælg handling', onSelect: (type) => setJobType(type), 
            // @ts-ignore
            static: jobType && lang.tribunalJobTypes[jobType], onRemoveStatic: () => setJobType(null), searchDelay: 0, forceOpen: true, searchAll: (q) => Object.values(TribunalJobType)
                .filter((type) => ((tribunalJobReferenceCaseMap[type] || []).includes(props.tribunalCase.type) ||
                Object.values(InternationalTribunalJobType).includes(type)) &&
                ![
                    TribunalJobType.CreateBetalingspaakrav,
                    TribunalJobType.GLCreateBetalingspaakrav,
                    TribunalJobType.CreateStaevning,
                    TribunalJobType.CreateFogedrekvisition,
                    TribunalJobType.CreateFogedbegaering,
                ].includes(type))
                .filter((type) => lang.tribunalJobTypes[type]
                .toLowerCase()
                .includes(q.toLowerCase()) || '')
                .map((type) => ({
                heading: lang.tribunalJobTypes[type],
                key: type,
                returnData: type,
            })) }),
        jobType && (React.createElement(React.Fragment, null,
            React.createElement(Well, null, Job[jobType]),
            React.createElement("br", null))),
        React.createElement("hr", null),
        React.createElement("br", null),
        React.createElement("div", null, tribunalCaseJobs.map((job) => {
            const user = job.createdByUserId && users
                ? users.find((user) => user.id === job.createdByUserId)
                : undefined;
            return (React.createElement(HistItem, { date: job.createdAt, key: job.id, options: [
                    {
                        label: lang.misc.delete,
                        onClick: async () => {
                            if (confirm('Are you sure you want to delete this?')) {
                                await tribunalAPI.delJob(job.id);
                                q.invalidate(keys.write.modify(tribunalJobsEntity, job.id));
                            }
                        },
                    },
                ], heading: React.createElement("div", null,
                    React.createElement("span", { style: { marginRight: '0.5em' } }, user && React.createElement(UserPreview, { user: user })),
                    lang.tribunalJobTypes[job.type]) },
                React.createElement(TribunalJob, { key: job.id, job: job, tribunalCase: props.tribunalCase })));
        }))));
};
export default TribunalCase;
//# sourceMappingURL=TribunalCaseJobs.js.map